import React, {useEffect} from 'react';
import {Platform} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {useQueryParam, StringParam} from 'use-query-params';

import {initRemoteConfig} from 'store/app/remoteConfigActions';
import {initDynamicLinkHandler} from 'store/app/linkActions';
import {initCache} from 'store/app/cacheActions';
import {
  setLegacyFlag,
  setDirectLanding,
  setReadyToMove,
  setAvatarURL,
  setCustomCourse,
} from 'store/meeting/actions/meeting';
import {setCurrentUnitId} from './store/course';
import {getWebLaunchToken, startWebSessionKeepAlive} from 'utils/webAuthSession';
import {WEB_APP_BASE_URL} from 'config/app.config';
import TrialDemo from 'components/TrialDemo/TrialDemo';
import {clearTrialDemo, markTrialDemo} from 'utils/trialDemo';
import {hasSavedAvatar} from 'utils/avaTwinAvatar';

const RemoteConfigHandler = () => {
  const dispatch = useDispatch();
  const isRemoteConfigLoaded = useSelector(
    state => state.app.isRemoteConfigLoaded,
  );

  useEffect(() => {
    if (Platform.OS === 'web') {
      if (!isRemoteConfigLoaded) {
        dispatch(initRemoteConfig());
      }
    }
  }, [isRemoteConfigLoaded]); // Add token to dependencies to ensure correctness

  // the portal's sign-in reaches past its hour here too: fresh access tokens from its bridge (Sol fix-review R4 A)
  useEffect(() => {
    if (Platform.OS === 'web') startWebSessionKeepAlive(WEB_APP_BASE_URL);
  }, []);

  // Web breaks for some reason using useEffect to call this
  console.log('RemoteConfigHandler', Date.now());

  return <></>;
};
const IntialLink = () => {
  const dispatch = useDispatch();
  const [queryToken] = useQueryParam('token', StringParam);
  const token = Platform.OS === 'web' ? getWebLaunchToken() || queryToken : queryToken;
  const [avatarSelectionString] = useQueryParam('avatarSelection', StringParam);
  const [avatarUrlString] = useQueryParam('avatarUrl', StringParam);
  const [customCourseString] = useQueryParam('customCourse', StringParam);
  const [showTrialDemo] = useQueryParam('showTrialDemo', StringParam);

  // Try Quik Demo (utils/trialDemo.js): the start link has no launch yet - sign the visitor in and launch the demo unit.
  if (Platform.OS === 'web' && !token && showTrialDemo === 'true') {
    return <TrialDemo />;
  }

  // avatarSelection
  if (Platform.OS === 'web' && token) {
    if (showTrialDemo === 'true') markTrialDemo();
    else clearTrialDemo();
    // 'true' becomes true, everything else becomes false. A player who has not created an
    // Ava-Twin avatar yet always starts on the customize_avatar screen, whatever the link says
    // (dashboard launches send avatarSelection=false).
    const avatarSelection = avatarSelectionString === 'true' || !hasSavedAvatar();
    // Legacy is fully deprecated: always run in non-legacy mode, regardless of URL params.
    const legacy = false;
    if (avatarUrlString) {
      dispatch(setAvatarURL(`${avatarUrlString}`));
    }
    const customCourse = customCourseString === 'true';
    dispatch(setDirectLanding(!avatarSelection));
    dispatch(setCustomCourse(customCourse));
    dispatch(setReadyToMove(false));
    dispatch(setLegacyFlag(legacy));
    dispatch(initDynamicLinkHandler(token, avatarSelection)); // Always executes once for web
  }
  return <></>;
};
export default () => {
  return (
    <>
      <RemoteConfigHandler />
      <IntialLink />
    </>
  );
};
